module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("8IaWw"))).then(() => parcelRequire('1iHdE'));